<template>
  <div
    class="pb-video-player row no-gutters"
    :class="{
    showPlaySwitchEffect,
    }"
  >
    <div class="main col min-w-0 p-0">
      <div ref="topContent" class="video-top-content" style="display: none;">
        <h2 class="episode-name" v-if="episode.title.length>0">
            <a  :target="episode.link?'_blank':'_self'" :href="episode.link || 'javascript:void();'">{{
              episode.title
            }}</a>
        </h2>
        <div class="pb-actions">
            <a
              class="subscribe"
              v-if="podcastApps.length>0"
              href="javascript:;"
              @click="isShowPodcastAppsDialog = true"
              title="Podcast Apps"
            >
              <icon-rss/>
            </a>
            <a
              target="_blank"
              class="downloadLink"
              v-if="download && episode.downloadLink"
              :href="episode.downloadLink"
              title="Download"
            >
              <icon-download />
            </a>
            <a
              class="share"
              v-if="share && episode.shareLink"
              href="javascript:;"
              @click="isShowShareDialog = true"
              title="Share"
            >
              <icon-share></icon-share>
            </a>
            <a
              class="info"
              v-if="info"
              href="javascript:;"
              @click="isShowInfoDialog = true"
              title="Info"
            >
              <icon-info></icon-info>
            </a>
            <a
                class="chapters"
                v-if="chapters.length>0"
                href="javascript:;"
                @click="isShowChaptersDialog = true"
                title="Chapter"
            >
              <icon-list-chapers></icon-list-chapers>
            </a>
          </div>

      </div>

      <div ref="empty" class="video-empty">&nbsp;</div>
      <div ref="podbeanLogo" class="podbean-logo row no-gutters" style="display:none;">
        <div v-if="setting.pbad" class="col-auto pb-brand-small-logo">
          <a
            class="logo"
            target="_blank"
            href="http://www.podbean.com?utm_campaign=pb_web_video_player&utm_medium=logo&utm_source=pb_web_player"
            title="Podbean"
          >
             <icon-podbean-logo></icon-podbean-logo>
          </a>
        </div>
      </div>


      <div class="pb-internal-player">
        <pb-player
          ref="pbPlayer"
          @ready="playerReady"
          :options="videoOptions"
          :type="episode.type"
          :startAt="startAt"
          :episode="episode"
          :crossorigin="episode.crossorigin"
        ></pb-player>
        <player-loading></player-loading>

      </div>

      <app-download
        class="text-left"
        v-show="showAppDownloadStatus === 1"
      ></app-download>

      <div ref="playSwitchEffect" class="video-play-paused-bg">
        <div title="Pause"><icon-pause class="text-white"></icon-pause></div>
        <div title="Play"><icon-play class="text-white"></icon-play></div>
      </div>
    </div>
    <share-dialog
      v-if="share && episode.shareLink"
      @hide="isShowShareDialog = false"
      v-show="isShowShareDialog"
    ></share-dialog>
    <info-dialog
      v-if="info"
      @hide="isShowInfoDialog = false"
      v-show="isShowInfoDialog"
    ></info-dialog>
    <podcast-apps-dialog @hide="isShowPodcastAppsDialog=false"  v-show="isShowPodcastAppsDialog"></podcast-apps-dialog>
    <chapters-list-dialog @seek-to-chapter-time="chapterGoTo" @hide="isShowChaptersDialog=false" v-show="isShowChaptersDialog"></chapters-list-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import PbPlayer from "@/components/PbPlayer";
import AppDownload from "@/components/AppDownload";
import ShareDialog from "@/components/ShareDialog";
import InfoDialog from "@/components/InfoDialog";
import IconDownload from "@/components/IconDownload";
import IconShare from "./icons/IconShare";
import IconInfo from "./icons/IconInfo";
import IconPodbeanLogo from "./icons/IconPodbeanLogo";
import PlayerLoading from "./PlayerLoading";
import PodcastAppsDialog from "./PodcastAppsDialog";
import IconRss from "./icons/IconRss";
import IconPause from "./icons/IconPause";
import IconPlay from "./icons/IconPlay";
import { guid, sleep } from "@/common/utils";
import ChaptersListDialog from '@/components/ChaptersListDialog.vue';
import IconListChapers from '../../live-player/src/components/icons/IconListChapers.vue';
import {MUTATION_UPDATE} from "@/store/mutations";

export default {
  name: "VideoPlayer",
  components: {
    IconListChapers,
    ChaptersListDialog,
    IconRss,
    PodcastAppsDialog,
    PlayerLoading,
    IconPodbeanLogo,
    IconShare,
    IconInfo,
    IconDownload,
    ShareDialog,
    InfoDialog,
    AppDownload,
    PbPlayer,
    IconPause,
    IconPlay,
  },
  mounted() {
    // let dom = document.createElement('div');
    // dom.style.backgroundImage = `url(${this.episode.logo})`;
    // dom.classList.add("logo-background");

    let dom = document.createElement('div');
    dom.classList.add("bg-mask");
    let bg_dom = document.createElement('div');
    bg_dom.style.backgroundImage = `url(${this.episode.logo})`;
    bg_dom.classList.add("logo-background");
    dom.appendChild(bg_dom);
    this.$refs.pbPlayer.player.addChild('DomRef',{dom});
  },
  watch: {
    async download() {
      await this.$nextTick();
      this.playerReady();
    },
    async episode() {
      await this.$nextTick();
      this.playerReady();
    },
    async share() {
      await this.$nextTick();
      this.playerReady();
    },
    async chapters() {
      await this.$nextTick();
      this.playerReady();
    },
    async playerPlaying(){
      this.showPlaySwitchEffect = false;
      await sleep(100);
      this.showPlaySwitchEffect = true;
      let localGuid = guid();
      this.globalGuid = localGuid;
      await sleep(400);
      if (localGuid === this.globalGuid) {
        this.showPlaySwitchEffect = false;
      }
    }
  },
  computed: {
    ...mapState([
      "setting",
      "startAt",
      "download",
      "share",
      "info",
      "showAppDownloadStatus",
      "podcastApps",
      "chapters",
      "playerPlaying",
      "showFullScreenToggle"
    ]),
    ...mapGetters(["episode"]),
    videoOptions() {
      return {
        language: "en",
        poster: this.episode.largeLogo,
        autoplay: false,
        controls: true,
        controlBar: {
          fullscreenToggle: this.showFullScreenToggle,
          durationDisplay: false,
          mouseTimeDisplay: false,
          children: [
            "playToggle",
            "currentTimeDisplay",
            "progressControl",
            "remainingTimeDisplay",
            // "currentTimeDisplay",
            "muteToggle",
            "volumeControl",
            "playbackRateMenuButton"
          ]
        },
        playbackRates: [0.75, 1, 1.25, 1.5, 2],
        bigPlayButton: true,
        sources: [
          {
            src: this.episode.resource,
            type: this.episode.resourceMimetype
          }
        ]
      };
    }
  },
  data() {
    return {
      timer: null,
      isShowShareDialog: false,
      isShowInfoDialog: false,
      isShowPodcastAppsDialog: false,
      showPlaySwitchEffect:false,
      globalGuid:null,
      isShowChaptersDialog: false,
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    chapterGoTo(seconds){
      this.isShowChaptersDialog = false;
      this.$refs.pbPlayer.setCurrentTime(seconds);
    },
    async playerReady(){
      let oldDom = this.$refs.pbPlayer.player.el().querySelector('.video-top-content');
      if (oldDom){
        oldDom.remove();
      }
      oldDom = this.$refs.pbPlayer.player.el().querySelector('.podbean-logo');
      if (oldDom){
        oldDom.remove();
      }

      let titleDom = this.$refs.topContent.cloneNode(true);
      let playSwitchEffectDom = this.$refs.playSwitchEffect.cloneNode(true);
      let emptyDom = this.$refs.empty.cloneNode(true);
      let podbeanLogoDom = this.$refs.podbeanLogo.cloneNode(true);
      this.$refs.pbPlayer.player.addChild('DomRef',{dom: titleDom});
      this.$refs.pbPlayer.player.addChild('DomRef',{dom: playSwitchEffectDom});
      this.$refs.pbPlayer.player.controlBar.addChild('DomRef',{dom: podbeanLogoDom});
      this.$refs.pbPlayer.player.controlBar.addChild('DomRef',{dom: emptyDom});
      await this.$nextTick();
      emptyDom.style.display = 'block';
      titleDom.style.display = 'block';
      podbeanLogoDom.style.display = 'block';
      let shareLink = titleDom.querySelector('.share');
      if (shareLink){
        shareLink.onclick = ()=>{
          this.setNonAppDownloadDialogOpen();
          this.isShowShareDialog = true;
        };
      }
      let infoLink = titleDom.querySelector('.info');
      if (infoLink){
        infoLink.onclick = ()=>{
          this.setNonAppDownloadDialogOpen();
          this.isShowInfoDialog = true;
        };
      }
      let subscribeLink = titleDom.querySelector('.subscribe');
      if (subscribeLink){
        subscribeLink.onclick = ()=>{
          this.setNonAppDownloadDialogOpen();
          this.isShowPodcastAppsDialog = true;
        };
      }

      let chapterLink = titleDom.querySelector('.chapters');
      if (chapterLink){
        chapterLink.onclick = ()=>{
          this.setNonAppDownloadDialogOpen();
          this.isShowChaptersDialog = true;
        };
      }

    },
    setNonAppDownloadDialogOpen() {
      this.$store.commit(MUTATION_UPDATE, ["isNonAppDownloadDialogOpen", true]);
    },
  }
};
</script>

<style lang="scss">
.btnSkin-1{
  .pb-audio-player{
    .video-js{
      .vjs-control-bar{
       .vjs-button{
         .vjs-icon-placeholder{
           &:before{
             font-size: 1.85em;
           }
         }
       }
      }
    }
  }
}
.player-status-playing,.player-status-pause{
  .pb-video-player{
   border: none;
  }
}
#app{
  display: flex;
  flex-direction: column;
}
.player-status-pause{
  .video-play-paused-bg{
    .bi-pause-fill{
      display: none;
    }
  }
}
.player-status-playing{
  .video-play-paused-bg{
    .bi-play-fill{
      display: none;
    }
  }
}


.player-status-loaded {
  .pb-player {
    .bg-mask {
      display: none;
    }
  }
}
.pb-video-player{
  height: 100%;
  flex-shrink: 0;
  position: relative;
  border: 1px solid #efefef;
  /*background: linear-gradient(90deg,#000000,#0c5056,#2a1844);*/

  &.showPlaySwitchEffect{
    .video-play-paused-bg{
      display: flex;
    }
  }

  .chapters-List-dialog{
    .share-content{
      max-height: 95%;
    }
  }

  /* 播放出错 */
  .vjs-error-display{
    .vjs-modal-dialog-content{
      top: 50%;
      margin-top: -0.5em;
      padding: 0 !important;
    }
  }
  .player-loading{
    height: 50%;
    .item{
      width: 7px;
      height: 7px;
    }
  }
  .vjs-has-started{
    .logo-background{
      display: none;
    }
  }
  .pb-internal-player{
    .vjs-has-started.vjs-user-inactive.vjs-playing{
      .video-top-content{
        opacity: 0;
        visibility: visible;
      }
    }
    .vjs-text-track-display{
      .vjs-text-track-cue{
        &>div{
          color: #ffffff !important;
        }
      }
    }
  }
  .vjs-poster{
    z-index: 999;
    background-color: transparent;
  }
  .vjs-big-play-button{
    z-index: 9999;
  }
  .video-top-content{
    //width: 100%;
    //height: 30px;
    //line-height: 30px;
    //top: 0;
    //padding: 0 5px;
    position: absolute;
    top: 10px;
    left: 12px;
    width: 65%;
    //flex: 1;
    z-index: 9;
    ////background-color: rgba(0, 0, 0, 0.7);
    //transition: visibility 0.1s, opacity 0.1s;

    &.playing{
      opacity: 0;
      &.userIsActive{
        opacity: 1;
      }
    }
    .episode-name{
      padding-left: 0;
      //margin-top: 10px;
      a{
        color: #ffffff;
        padding: 9px 12px;
        margin-left: 0;
        font-size: 14px;
        display: inline-block;
        animation: unset;
        transform: unset;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
        //background-color: #569;
        background-color: rgba(0, 0, 0, 0.7);
      }
    }
    .pb-actions{
      position: fixed;
      right: 12px;
      top: 10px;
      a{
        width: 34px;
        height: 34px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:not(:first-child){
          margin-top: 5px;
        }
        .bi-info-circle{
          width: 19px;
          height: 19px;
        }
      }
      svg{
        color: #ffffff;
      }
      .icon-download{
        width: 22px;
        height: 22px;
        position: relative;
        top: -1px;
      }
    }
  }
  .vjs-big-play-button{
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  .pb-internal-player{
    height: 100%;
    .pb-player{
      height: 100%;
      .video-js{
        height: 100%;
      }
    }
  }
  .no-gutters{
    z-index: 999;
  }

  /* video-play-paused animation */
  .video-play-paused-bg{
      display: none;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 49%;
      text-align: center;
      z-index: 9;
      margin: auto;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      background-color: rgba(0,0,0,0.5);
      border-radius: 50px;
      -webkit-animation: video-fadeout .4s linear 1 normal forwards;
      animation: video-fadeout .4s linear 1 normal forwards;
      pointer-events: none;
      svg{
        color: #ffffff;
      }
      .bi-pause-fill{
        width: 20px;
        height: 20px;
      }
      .bi-play-fill{
        margin-left: 4px;
        width: 22px;
        height: 22px;
      }
     @-webkit-keyframes video-fadeout{
       0%{opacity:1}to{opacity:0;-webkit-transform:scale(1.8);transform:scale(1.8)}
     }
     @keyframes video-fadeout{
       0%{opacity:1}to{opacity:0;-webkit-transform:scale(1.8);transform:scale(1.5)}
     }

    }




  .video-js{
    width: 100%;
    overflow: hidden;
    .video-play-paused-bg{
      display: none !important;
    }

      /* 播放条 */
    .vjs-control-bar {
      height: 50px;
      //overflow: hidden;
      background-color: transparent;
      background-image: linear-gradient(180deg, rgb(0 0 0 / 0%), rgb(0 0 0 / 75%));
      .vjs-control:focus{
        text-shadow: none !important;
      }
      /* 音量控制 */
      .vjs-mute-control,.vjs-volume-control{
        margin-top: 14px;
        order: 5;
      }
      .vjs-mute-control{
        color: var(--player-btn-color);
        .vjs-mouse-display{
          padding: 1.4em 0;
        }
      }
      .vjs-mute-control{
        color: var(--player-btn-color);
      }
      .vjs-volume-control{
        margin: 1.35em .45em 1.35em 0em;
        .vjs-volume-bar{
          &:before{
            content: '';
            position: absolute;
            top: -15px;
            left: -15px;
            right: -15px;
            bottom: -15px;
            z-index: 1;
          }
          .vjs-volume-bar.vjs-slider-horizontal{
            background-color:rgba(115, 133, 159, 0.5)
          }
        }
        .vjs-slider-horizontal {
          .vjs-volume-level{
            background-color: var(--player-btn-color) !important;
          }
        }
      }

      .vjs-progress-control{
        width: 100%;
        position: absolute;
        top: 3px;
        height: 6px;
        .vjs-progress-holder{
          margin: 0 12px;
          font-size: 12px;
        }
        &:hover{
          .vjs-progress-holder{
            font-size: 12px;
            .vjs-play-progress{
              &:before{
                 top: -0.33333333em;
              }
            }
          }
        }
      }
      .vjs-play-control {
        order: 1;
        margin-top: 12px;
        text-shadow: none;
        background-color: transparent !important;
        &:hover{
           opacity: 0.85;
        }
        .vjs-icon-placeholder {
          &:before {
            font-size: 32px;
            color: var(--player-btn-color);
            line-height: 1.1;
          }
        }
      }
      .vjs-ended{
        .vjs-icon-placeholder {
          &:before {
            font-size: 24px;
            padding-top: 2px;
          }
        }
      }
      .play-next-button{
        order: 2;
      }
      .vjs-time-control{
        margin-top: 14px;
        span{
          font-size: 12px;
        }
      }
      .vjs-current-time{
        display: block;
        order: 3;
        padding-right: 6px;
        .vjs-current-time-display{
          &::after{
            content: "";
            display: inline-block;
            height: 12px;
            width: 1px;
            background-color: #ffffff;
            margin-left: 7px;
            transform: rotate(17deg);
            position: relative;
            top: 2px;
          }
        }
      }
      .vjs-remaining-time{
        padding-left: 0;
         order: 4;
      }
      .video-empty{
        order: 5;
        flex: auto;
        display: none;
        align-items: center;
        min-width: 4em;
        touch-action: none;
        height: 5px;
        margin-top: 20px;
      }
      .vjs-menu-button-popup{
        order: 6;
        width: 3em;
        margin-top: 10px;
        margin-right: 8px;
        .vjs-playback-rate-value{
          font-size: 12px;
          margin-top: 8px;
        }
        .vjs-menu{
          .vjs-menu-content{
            border-radius: 25px;
            width: 50px;
            padding-top: 14px;
            padding-bottom: 14px;
            box-shadow: 0 5px 10px rgb(0 0 0 / 25%);
            background-color: #ffffff;
            .vjs-menu-item{
              color: #1a1a1a;
              padding: 3px 0;
              font-size: 13px;
              &:hover{
                background-color: transparent;
              }
            }
            .vjs-selected{
              background-color: transparent;
              color: var(--player-btn-color);
            }
         }
        }
      }

      .vjs-fullscreen-control{
        width: 3em;
        order: 8;
        margin-top: 13px;
        margin-right: 9px;
        opacity: 1;
        &:hover{
          opacity: 0.85;
        }
        .vjs-icon-placeholder{
          &::before{
            color: #ffffff;
            font-size: 22px;
            line-height: 1.6;
          }
        }
      }
      .podbean-logo{
        order: 9;
        margin-top: 14px;
        margin-right: 10px;
        .pb-brand-small-logo{
          .logo{
            svg{
              width: 46px;
              height: 22px;
              padding-top: 6px;
              margin-right: 3px;
               color: #ffffff;
            }
          }
        }
      }



    }



    .vjs-time-control {
      span {
        color: #ffffff !important;
        opacity: 1;
      }
    }
  }
  /* download-dialog */
  .download-dialog{
    p{
      font-size: 16px;
    }
    .title {
      font-size: 20px;
    }
  }
  .bg-mask {
    z-index: 99;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    overflow: hidden;
    background-color: #a5a5a5;
  }
  .logo-background{
    width: 100%;
    height: 100%;
    -webkit-filter: blur(30px); /* Chrome, Opera */
    -moz-filter: blur(30px);
    -ms-filter: blur(30px);
    filter: blur(30px);
    z-index: 99;
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    cursor: pointer;
    padding: 0;
    position: absolute;
    background-size: cover;
    transform: scale(1.2);
  }
}

@media (max-width: 767px){
  _::-webkit-full-page-media, _:future, :root .vjs-mute-control{
    display: none !important;
  }
  _::-webkit-full-page-media, _:future, :root .vjs-volume-control{
    display: none !important;
  }
}
</style>
